"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpLabeledListGroupItem = void 0;
const _ = __importStar(require("lodash"));
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const labeled_list_group_item_html_1 = __importDefault(require("./labeled-list-group-item.html"));
let ItpLabeledListGroupItem = class ItpLabeledListGroupItem extends vue_1.default {
    isExpanded;
    label;
    labelCols;
    helpTooltip;
    helpText;
    content;
    collapsible;
    expandable;
    expanderCols;
    stateKey;
    alwaysDisplay;
    condensed;
    data() {
        return {
            isExpanded: this.getIsExpanded()
        };
    }
    onIsExpandedChange(isExpanded) {
        if (this.isExpandable && this.stateKey) {
            this.$app.objectStore.setItem(`panel.${this.stateKey}`, { isExpanded });
        }
    }
    get className() {
        return {
            'itp-labeled-list-group-item': true,
            'list-group-item': true,
            'condensed': this.condensed,
            collapsible: this.isExpandable,
            expanded: this.isExpanded
        };
    }
    get labelClass() {
        return [
            'itp-labeled-list-group-item__label',
            `col-md-${this.labelCols}`
        ];
    }
    get contentClass() {
        return [
            'itp-labeled-list-group-item__content',
            `col-md-${12 - this.labelCols}`
        ];
    }
    get expanderClass() {
        const w = this.expanderCols || 9;
        return `col-md-${w} pt-2`;
    }
    get iconName() {
        if (this.collapsible) {
            return this.isExpanded ? 'fa-angle-down' : 'fa-angle-right';
        }
    }
    get isExpandable() {
        return this.collapsible || this.expandable;
    }
    get isVisible() {
        return (this.content !== null && this.content != '') || this.alwaysDisplay;
    }
    onClick() {
        if (this.expandable) {
            this.isExpanded = !this.isExpanded;
        }
    }
    getIsExpanded() {
        if (this.isExpandable && this.stateKey) {
            const value = this.$app.objectStore.getItem(`panel.${this.stateKey}`, null);
            if (value && _.isBoolean(value.isExpanded)) {
                return value.isExpanded;
            }
        }
        return false;
    }
};
exports.ItpLabeledListGroupItem = ItpLabeledListGroupItem;
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null, type: String }),
    __metadata("design:type", String)
], ItpLabeledListGroupItem.prototype, "label", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 3, type: Number }),
    __metadata("design:type", Number)
], ItpLabeledListGroupItem.prototype, "labelCols", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null, type: String }),
    __metadata("design:type", String)
], ItpLabeledListGroupItem.prototype, "helpTooltip", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null, type: String }),
    __metadata("design:type", String)
], ItpLabeledListGroupItem.prototype, "helpText", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null, type: String }),
    __metadata("design:type", String)
], ItpLabeledListGroupItem.prototype, "content", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpLabeledListGroupItem.prototype, "collapsible", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpLabeledListGroupItem.prototype, "expandable", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null, type: String }),
    __metadata("design:type", String)
], ItpLabeledListGroupItem.prototype, "expanderCols", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null, type: String }),
    __metadata("design:type", String)
], ItpLabeledListGroupItem.prototype, "stateKey", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpLabeledListGroupItem.prototype, "alwaysDisplay", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpLabeledListGroupItem.prototype, "condensed", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('isExpanded'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ItpLabeledListGroupItem.prototype, "onIsExpandedChange", null);
exports.ItpLabeledListGroupItem = ItpLabeledListGroupItem = __decorate([
    (0, vue_property_decorator_1.Component)({ template: labeled_list_group_item_html_1.default })
], ItpLabeledListGroupItem);
//# sourceMappingURL=labeled-list-group-item.js.map